import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή</title>
        <meta name="description" content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας" />
      </Helmet>

      <div style={{ padding: '40px 20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#003366', textAlign: 'center', marginBottom: '30px' }}>Πολιτική Απορρήτου</h1>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>1. Εισαγωγή</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Η Halecor δεσμεύεται να προστατεύει το απόρρητο των επισκεπτών και των μαθητών της. 
          Αυτή η πολιτική απορρήτου εξηγεί πώς χρησιμοποιούμε τις προσωπικές πληροφορίες που συλλέγουμε 
          μέσω της ιστοσελίδας μας και των υπηρεσιών μας.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>2. Συλλογή Πληροφοριών</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Συλλέγουμε τις ακόλουθες πληροφορίες:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Ονοματεπώνυμο</li>
          <li>Διεύθυνση email</li>
          <li>Αριθμός τηλεφώνου</li>
          <li>Ηλικία και επίπεδο εμπειρίας</li>
          <li>Προτιμήσεις μαθημάτων και μουσικών οργάνων</li>
          <li>Στοιχεία πληρωμής (μέσω ασφαλών τρίτων παρόχων)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>3. Χρήση Πληροφοριών</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Χρησιμοποιούμε τις πληροφορίες σας για:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Την παροχή και διαχείριση των μουσικών μαθημάτων</li>
          <li>Την επικοινωνία μαζί σας σχετικά με τα μαθήματα και τις υπηρεσίες μας</li>
          <li>Την επεξεργασία πληρωμών και την τήρηση λογιστικών αρχείων</li>
          <li>Τη βελτίωση των υπηρεσιών και της εμπειρίας σας</li>
          <li>Την αποστολή ενημερώσεων, προσφορών και εκπαιδευτικού υλικού</li>
          <li>Τη συμμόρφωση με νομικές υποχρεώσεις</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>4. Προστασία Δεδομένων</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Λαμβάνουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των προσωπικών σας δεδομένων 
          από μη εξουσιοδοτημένη πρόσβαση, απώλεια ή καταστροφή. Τα δεδομένα αποθηκεύονται σε ασφαλείς 
          διακομιστές με κρυπτογράφηση και περιορισμένη πρόσβαση.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>5. Κοινοποίηση σε Τρίτους</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Δεν πουλάμε, δεν ανταλλάσσουμε ούτε μεταβιβάζουμε τα προσωπικά σας δεδομένα σε τρίτους, 
          εκτός από τους εξουσιοδοτημένους παρόχους υπηρεσιών που μας βοηθούν στη λειτουργία της 
          ιστοσελίδας και των υπηρεσιών μας, εφόσον συμφωνούν να τηρούν αυτές τις πληροφορίες εμπιστευτικές.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>6. Cookies</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στην ιστοσελίδα μας. Τα cookies 
          είναι μικρά αρχεία που αποθηκεύονται στον υπολογιστή σας και μας βοηθούν να αναλύσουμε την 
          επισκεψιμότητα και να προσαρμόσουμε το περιεχόμενο. Μπορείτε να απενεργοποιήσετε τα cookies 
          από τις ρυθμίσεις του προγράμματος περιήγησής σας.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>7. Τα Δικαιώματά Σας</h2>
        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '10px' }}>
          Σύμφωνα με τον GDPR, έχετε τα ακόλουθα δικαιώματα:
        </p>
        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '20px' }}>
          <li>Δικαίωμα πρόσβασης στα προσωπικά σας δεδομένα</li>
          <li>Δικαίωμα διόρθωσης ανακριβών δεδομένων</li>
          <li>Δικαίωμα διαγραφής των δεδομένων σας</li>
          <li>Δικαίωμα περιορισμού της επεξεργασίας</li>
          <li>Δικαίωμα φορητότητας των δεδομένων</li>
          <li>Δικαίωμα εναντίωσης στην επεξεργασία</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>8. Ανήλικοι</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Για την εγγραφή ανηλίκων μαθητών απαιτείται η συγκατάθεση των γονέων ή κηδεμόνων. 
          Τα προσωπικά δεδομένα ανηλίκων προστατεύονται με ιδιαίτερη προσοχή και χρησιμοποιούνται 
          αποκλειστικά για εκπαιδευτικούς σκοπούς.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>9. Αλλαγές στην Πολιτική</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Διατηρούμε το δικαίωμα να ενημερώνουμε αυτήν την πολιτική απορρήτου ανά πάσα στιγμή. 
          Οι αλλαγές θα δημοσιεύονται στην ιστοσελίδα μας και θα ισχύουν αμέσως μετά τη δημοσίευσή τους. 
          Σας ενθαρρύνουμε να ελέγχετε τακτικά την πολιτική για τυχόν ενημερώσεις.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#003366', marginBottom: '15px' }}>10. Επικοινωνία</h2>
        <p style={{ lineHeight: '1.8', color: '#333' }}>
          Για οποιεσδήποτε ερωτήσεις σχετικά με την πολιτική απορρήτου μας ή για να ασκήσετε 
          τα δικαιώματά σας, μπορείτε να επικοινωνήσετε μαζί μας:
        </p>
        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '10px' }}>
          <strong>Email:</strong> <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a><br />
          <strong>Τηλέφωνο:</strong> +30 210 1234567<br />
          <strong>Διεύθυνση:</strong> Οδός Μουσικής 123, Αθήνα 10678, Ελλάδα
        </p>
      </section>

      <section style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
        <p style={{ lineHeight: '1.8', color: '#666', fontSize: '14px', textAlign: 'center' }}>
          Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}
        </p>
      </section>
    </div>
  
    </>);
};

export default PrivacyPolicy;